import axios from "axios";

export const SITE_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${SITE_URL}/api`, withCredentials: true });

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Etwas ist schiefgelaufen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}

export async function uploadImage(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/admin/media", form);
  return data.url;
}
